import { AppEnvironment } from './utils.js';

const AppEnvironmentMap = {
  local: AppEnvironment.DEV,
  dev: AppEnvironment.DEV,
  rt: AppEnvironment.ALPHA,
  alpha: AppEnvironment.ALPHA,
  beta: AppEnvironment.BETA,
  preprod: AppEnvironment.BETA,
  prod: AppEnvironment.PRODUCTION,
  production: AppEnvironment.PRODUCTION,
  prd: AppEnvironment.PRODUCTION
};
function createClientHeadersInterceptor({
  clientId,
  appVersion,
  environment,
  appName,
  profileToken,
  clientType
}) {
  async function interceptor(axiosRequestConfig) {
    const [clientVersion, profileTokenValue] = await Promise.all([
      typeof appVersion === "function" ? appVersion() : appVersion,
      typeof profileToken === "function" ? profileToken() : profileToken
    ]);
    const modifiedConfig = { ...axiosRequestConfig };
    modifiedConfig.headers["x-client-id"] = clientId;
    modifiedConfig.headers["x-client-version"] = clientVersion;
    modifiedConfig.headers["x-environment"] = AppEnvironmentMap[environment];
    modifiedConfig.headers["x-app"] = appName;
    if (clientType)
      modifiedConfig.headers["x-client-type"] = clientType;
    if (profileTokenValue)
      modifiedConfig.headers["x-profile-token"] = profileTokenValue;
    return modifiedConfig;
  }
  return interceptor;
}

export { createClientHeadersInterceptor };
//# sourceMappingURL=clientHeaders.js.map
